import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import '../../asset/css/stepbystepform.css';
import {
    fetchUtilData,
    handleInput,
    renderListPrivate,
    renderForm, removeEntry
} from "../generic/databases-function";
import {GetUserToken} from "../../api/services";
import eConfig from "../../config";

const options = ["yes", "no"];
const optionsCountry = ["usa", "sa", "congo", "DRC"];

export default class ComFieldCampaign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            newEntry: {},
            showList: true,
            cqlTable: "Campaign",
            listField: [
                {
                    field: "Name",
                    label: "Name",
                    options: options,
                    type: "text",
                    required: true
                },
                {
                    field: "Description",
                    label: "Description",
                    options: options,
                    type: "text",
                    required: true
                },
                {
                    field: "StartDate",
                    label: "Start Date",
                    options: options,
                    type: "date",
                    required: true
                },
                {
                    field: "EndDate",
                    label: "EndDate",
                    options: options,
                    type: "date",
                    required: true
                },

            ]

        }
    }

    async componentDidMount() {
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await fetchUtilData(this,"otp", "Campaign", "Data");
    }

    fetchApi = async (url, hub, method, callback) => {
        console.log("$$$$$----> ", url);
        fetch(url, {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((response) => {
                callback(response, null);
            }).catch((e) => {
            callback(null, e, null);
        });
    }

    submitEntry = async (e, table, addData, _this) => {
        e.preventDefault();
        if (!window.confirm("Are you sure that you want to submit?")) {
            return
        }

        let entry = {..._this.state.newEntry};
        entry.Org = GetUserToken().OrgCode;
        for (let i in addData) {
            const row = addData[i];
            if (typeof row.type !== "undefined") {
                if (row.type === "hidden") {
                    entry[row.field] = row.defaultValue;
                }
            }
        }
        //todo let add our default variable

        let hub = {...entry};

        let backend = eConfig.otpBackend;
        let endpoint = "/api/campaign/new";
        let url = eConfig.serverBackendOtp + "/" + backend + endpoint;

        await this.fetchApi(url, hub, "POST", async (dataIn, err) => {
            console.log("submitEntry *** response > ", dataIn);
            if (dataIn !== null) {
                if (typeof dataIn.RESULT !== "undefined") {
                    alert("Thank you Record submitted!");
                    let tmp = _this.state;
                    tmp.showList = true;
                    _this.setState(tmp);
                    await _this.loadInitialData();
                }
            }

        });

    }

    renderList = () => {
        const keyList = [];
        for (let i in this.state.listField) {
            const row = this.state.listField[i];
            keyList.push({
                field: row.field.toLocaleLowerCase(),
                label: row.field.toLocaleUpperCase()
            });
        }
        console.log("listField %%%%%%--->",keyList);
        const deleteKey = ["org", "name"];
        const deleteTable = this.state.cqlTable;
        const sortKey = "name";
        return renderListPrivate(this, "Data", keyList, deleteKey, deleteTable, "showList", removeEntry, sortKey)
    }
    renderForm = () => {
        return renderForm(this.state.listField, "showList", this.state.cqlTable, this, this.submitEntry)
    }

    render() {

        let _this = this;
        return (
            <PageContentWallpaper {...this.props} >


                <div>

                    <div className="row">
                        <div className="col col-xs-12">
                            <h3>
                                Manage Campaign

                                {this.state.showList ?
                                    <a className={"btn btn-primary pull-right"}
                                       onClick={(e) => handleInput(e, "showList", false, _this)}>Add New Record</a>
                                    :
                                    <a className={"btn btn-danger pull-right"}
                                       onClick={(e) => handleInput(e, "showList", true, _this)}>Cancel Adding new
                                        Record</a>
                                }
                            </h3>
                        </div>
                    </div>

                    {this.state.showList ? this.renderList() : this.renderForm()}
                </div>
            </PageContentWallpaper>
        )
    }


}
